import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: 'actualizar-clave',
    title: 'Actualizar clave',
    data: { title: 'Actualizar clave', withPadding: true },
    loadComponent: () => import('./pages/actualizar-clave/actualizar-clave.component'),
  },
];
